var render = function render(_c,_vm){return (_vm.props.name)?_c('img',{class:_vm.$options.methods.classes(_vm.props.name, _vm.data),attrs:{"src":_vm.$options.methods.getAsset(_vm.props.name, _vm.props.variant)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }